import React from "react";

const NFT = () => {
  return <div>NFT</div>;
};

export default NFT;
